const actions = {
  STORE_ARTICLE: 'publishingDesk/STORE_ARTICLE',
  STORE_ARTICLE_SUCCESS: 'publishingDesk/STORE_ARTICLE_SUCCESS',
}

export default actions
